const ITEMS = [
  {
    title: 'Verified astrologer',
    desc: 'Every expert is ID-checked before onboarding',
    path: 'M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z',
    extraPath: 'm9 12 2 2 4-4',
  },
  {
    title: 'Free rescheduling',
    desc: 'Change your slot up to 4 hours before',
    path: 'M3 12a9 9 0 0 1 15.3-6.36M21 3v6h-6M21 12a9 9 0 0 1-15.3 6.36M3 21v-6h6',
  },
  {
    title: 'Secure payments',
    desc: 'Encrypted checkout on every booking',
    path: 'M7 11V7a5 5 0 0 1 10 0v4',
    extraRect: true,
  },
  {
    title: 'Round-the-clock support',
    desc: 'Reach us on WhatsApp or live chat anytime',
    path: 'M18 8a6 6 0 0 0-12 0v7M3 18v-3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Zm16 0v-3a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2Z',
  },
]

export default function BookingTrustSection() {
  return (
    <section className="container px-6 mx-auto mt-16">
      <div className="astro-divider mb-10" />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {ITEMS.map((item) => (
          <div key={item.title} className="flex items-start gap-3">
            <span
              className="mt-0.5 inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-[#1C140A] shadow-[0_6px_16px_-6px_rgba(212,175,55,.5)]"
              style={{ background: 'linear-gradient(135deg, #D4AF37 0%, #F7D08F 100%)' }}
            >
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                {item.extraRect && <rect width="18" height="11" x="3" y="11" rx="2" />}
                <path strokeLinecap="round" strokeLinejoin="round" d={item.path} />
                {item.extraPath && <path strokeLinecap="round" strokeLinejoin="round" d={item.extraPath} />}
              </svg>
            </span>
            <div>
              <p className="text-sm font-semibold text-[#1C140A]">{item.title}</p>
              <p className="text-xs text-[#8B7355] mt-0.5 leading-relaxed">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
